// O código de erro da Meta (WhatsApp Cloud API) → o texto que a tela mostra e o
// grupo dele. Uma cópia só (PLAN D8): o servidor só extrai o código
// (`Reports::Campanhas::MotivoDaMeta`), e o texto mora aqui, nas chaves
// `CAMPANHAS.META_ERRORS.*` de `report.json`. Código que a tela não conhece tem
// um texto genérico, com o número: nunca some.
//
// Os grupos dizem o que fazer com a falha: o destinatário (número fora do
// WhatsApp), o pedido para parar, o template, a janela de 24 horas, o limite de
// envio, a conta na Meta, a mídia e a própria Meta.
export const META_ERROR_GROUPS = [
  'recipient',
  'opt_out',
  'template',
  'window',
  'limit',
  'account',
  'media',
  'meta',
  'other',
];

export const META_ERROR_CODES = Object.freeze({
  131026: 'recipient',
  131021: 'recipient',
  130472: 'recipient',
  131050: 'opt_out',
  132000: 'template',
  132001: 'template',
  132005: 'template',
  132007: 'template',
  132012: 'template',
  132015: 'template',
  132016: 'template',
  131008: 'template',
  131009: 'template',
  131047: 'window',
  130429: 'limit',
  131048: 'limit',
  131049: 'limit',
  131056: 'limit',
  80007: 'limit',
  4: 'limit',
  131031: 'account',
  131042: 'account',
  131045: 'account',
  131057: 'account',
  133010: 'account',
  130497: 'account',
  368: 'account',
  190: 'account',
  10: 'account',
  131005: 'account',
  131051: 'media',
  131052: 'media',
  131053: 'media',
  131000: 'meta',
  131016: 'meta',
  135000: 'meta',
  1: 'meta',
  2: 'meta',
});

// O código chega como texto (`"131026"`) ou número.
const known = code =>
  code !== null &&
  code !== undefined &&
  Object.prototype.hasOwnProperty.call(META_ERROR_CODES, String(code));

export const metaErrorGroup = code =>
  known(code) ? META_ERROR_CODES[String(code)] : 'other';

export const metaErrorText = (t, code) =>
  known(code)
    ? t(`CAMPANHAS.META_ERRORS.CODES.C${code}`)
    : t('CAMPANHAS.META_ERRORS.UNKNOWN', { code });

export const metaErrorGroupLabel = (t, group) =>
  t(
    `CAMPANHAS.META_ERRORS.GROUPS.${(META_ERROR_GROUPS.includes(group) ? group : 'other').toUpperCase()}`
  );
